import { Theme } from '@material-ui/core';

export const muiChipOverrides = (theme: Theme): Theme['overrides'] => ({
  MuiChip: {
    root: {
      fontSize: 13,
      lineHeight: 1.39,
      fontWeight: 400,
      fontFamily: 'Poppins',
    },
    deleteIcon: {
      width: '14px',
      marginRight: theme.spacing(1),
    },
    deleteIconSmall: {
      width: '9px',
      marginRight: theme.spacing(0.5),
    },
  },
});
